import React, { useState } from 'react'
import propTypes from 'prop-types'

export const CustomToolTip = React.memo(({ children, className, content, placement }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className='relative w-full' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            {showTooltip && <span className={`${className} absolute left-6 top-4 text-white px-2 py-1 text-xs bg-black min-w-fit z-50 rounded`}>
                  {content}</span>}
         </div>
    )
})

CustomToolTip.propTypes ={
    children:propTypes.any,
    className:propTypes.string,
    content:propTypes.any
}

CustomToolTip.defaultProps = {
    children:"",
    className:" max-w-md w-full ",
    content:""
}